import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSpine, getSpineStatus } from "../../api/features/spine/selectors";
import { fetchSpineDataIfNeeded } from "../../api/features/spine/actions";

export default function useSpine() {
  const loadStatus = useSelector(getSpineStatus);
  const spineData = useSelector(getSpine);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSpineDataIfNeeded());
  }, [dispatch]);

  return {
    spineData,
    loadStatus,
  };
}
